import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { SessionService } from './core/services/session.service';
import { ToastComponent } from './shared/components/toast/toast.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    imports: [RouterModule, ToastComponent]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'UE OS';

  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    // Initialize session timeout tracking
    this.sessionService.init();

    // Handle working_hours_blocked event
    window.addEventListener('working_hours_blocked', (e: Event) => {
      const reason = (e as CustomEvent).detail?.reason || 'outside_hours';
      // For now just log; in Phase 2 we'll show BlockedScreen
      console.warn('Working hours blocked:', reason);
    });
  }

  ngOnDestroy(): void {
    this.sessionService.destroy();
  }
}
